// Shared plan-discount math for the /pricing screen and the inline chat
// paywall widget, so both surfaces always show the same percentage.

import type { Plan } from '../types/api'

// TODO: this discount percentage is derived client-side from price/duration_days.
// It silently breaks if plan pricing shapes change — consider having the backend
// compute and serve a `discount_pct` field on the plan instead.
export function discountPercent(plan: Plan, featuredPlan: Plan | undefined): number | null {
  if (!featuredPlan || plan.id === featuredPlan.id) return null
  if (plan.token_based || !plan.recurring) return null
  if (!plan.duration_days || !featuredPlan.duration_days) return null
  if (plan.price == null || featuredPlan.price == null) return null
  const planPerDay = plan.price / plan.duration_days
  const featuredPerDay = featuredPlan.price / featuredPlan.duration_days
  if (planPerDay >= featuredPerDay) return null
  return Math.round((1 - planPerDay / featuredPerDay) * 100)
}

export function formatDuration(days: number | null | undefined): string {
  if (days == null) return ''
  if (days < 1) {
    const hours = Math.round(days * 24)
    return `${hours} ${hours === 1 ? 'час' : hours < 5 ? 'часа' : 'часов'}`
  }
  if (days === 1) return '24 часа'
  // 2–4 (кроме 12–14) → «дня»: тариф «Программа» — 84 дня, не «84 дней».
  const mod10 = days % 10
  const mod100 = days % 100
  const noun = mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20) ? 'дня' : 'дней'
  return `${days} ${noun}`
}
